import {Breadcrumb, Col, Divider, Row} from "antd";
import React, {useEffect, useState} from "react";
import axios from "axios";

function Portfolio() {

    const [content, setContent] = useState({});

    const [skeleton, setSkeleton] = useState(true);

    const apiKey = process.env.REACT_APP_STRAPI_CMS_API_KEY;

    const toggleSceleton = (value, key) => {
        if (key in value) {
            setSkeleton(false);
        } else {
            setSkeleton(true);
        }
    }

    const getMenu = async () => {
        const response = await axios.get(
            process.env.REACT_APP_STRAPI_URL + "/api/portfolio/?populate[PortfolioList][populate][Logo]=*",
            {
                headers: {
                    'Authorization': 'Bearer ' + apiKey
                }
            }
        )

        const content = response.data.data.attributes;

        setContent(content);
        toggleSceleton(content, 'Title');
    }

    useEffect(() => {
        getMenu().then(r => {});
    }, []);

    return (<>
            <Row gutter={24} className={"Content"} style={{paddingBottom: 0}}>
                <Col span={12}>
                    <h1>{content.PageTitle}</h1>
                </Col>
                <Col span={12} style={{textAlign: "right"}}>
                    <Breadcrumb
                        style={{float: "right"}}
                        items={[
                            {
                                href: '/',
                                title: (
                                    <>
                                        <span>Home</span>
                                    </>
                                ),
                            },
                            {
                                title: 'Portfolio',
                            },
                        ]}
                    />
                </Col>
            </Row>

            <Row gutter={24} className={"Content"} style={{textAlign: "center", paddingTop: 0}}>
                <Col span={24}>
                    <h2>{content.PageSubTitle}</h2>
                    <Divider className={"TransitionColors"} orientation="left">{content.Quote}</Divider>
                </Col>
            </Row>

            <Row gutter={24} className={"Content"} style={{textAlign: "center", paddingBottom: 120}}>
                {(content?.PortfolioList ?? []).map((value, key) => {
                    return <Col style={{padding: "24px 48px", margin: "auto"}} key={key}>
                            <a href={value.Link} target={"_blank"}>
                                <img style={{maxWidth: 160}}  src={process.env.REACT_APP_STRAPI_URL + value.Logo.data.attributes.url} alt=""/>
                            </a>
                        </Col>

                })}
            </Row>
        </>
    )
}

export default Portfolio